import { Injectable } from '@angular/core';
import { SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import {
    AddLocationType,
    EditLocationType,
    LocationType, LocationTypeParams, LocationTypeWithPage,
} from '@app/interfaces/rm/location-type';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LocationTypeService {
    private baseUrl = environment.api.services.rm + '/location-types';

    constructor(private http: HttpClient) {
    }

    async find(params: LocationTypeParams): Promise<LocationTypeWithPage> {
        return lastValueFrom(this.http.get<LocationTypeWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params)
        }));
    }

    async options(): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`));
    }

    async detail(params: { id: number }): Promise<LocationType> {
        return lastValueFrom(this.http.get<LocationType>(`${this.baseUrl}/one`, {
            params: Object.assign(params)
        }));
    }

    async add(params: AddLocationType): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, params));
    }

    async edit(data: EditLocationType): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: string): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }
}
